import React from "react";
import { withLocalize } from "react-localize-redux";
import { connect as connectFormik } from 'formik';
import BbFormikCheckbox from "../../styling/bbFormikCheckbox";

class Premises extends React.Component {
    render() {
        return (
            <div className="columns">
                <div className="column" style={{ display: "flex", flexWrap: "wrap" }}>
                    <BbFormikCheckbox name="premises.actual" label={this.props.translate("Search.Marketing.OnlyActual")} id="actual" />
                    <BbFormikCheckbox name="premises.historical" label={this.props.translate("Search.Marketing.AlsoHistorical")} id="historical" />
                </div>
            </div>
        )
    }
}

export default withLocalize(connectFormik(Premises));



